
import React, { useMemo, useState } from 'react';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import AuthPage from '@/pages/AuthPage';
import DashboardPage from '@/pages/DashboardPage';
import UpdatePasswordPage from '@/pages/UpdatePasswordPage';
import { Toaster } from '@/components/ui/toaster';
import { useDataManagement } from '@/hooks/useDataManagement';
import TermsAcceptanceDialog from '@/components/TermsAcceptanceDialog';
import { useToast } from '@/components/ui/use-toast';
import AdminLayout from '@/components/admin/AdminLayout';
import AccessControl from '@/components/AccessControl';
import NotebookDrawer from '@/components/NotebookDrawer';
import HelpCenterPage from '@/pages/HelpCenterPage';
const AppContent = () => {
  if (window.location.pathname.startsWith('/ajuda')) {
    return <HelpCenterPage />;
  }
  const { session, user, loading, updateUserMetadata, signOut, recoveryMode } = useAuth();
  const dataManagement = useDataManagement();
  const { toast } = useToast();
  const [acceptingTerms, setAcceptingTerms] = useState(false);

  const needsTermsAcceptance = Boolean(session && user && !user.user_metadata?.terms_accepted_at);

  const dashboard = useMemo(() => {
    return <DashboardPage dataManagement={dataManagement} />;
  }, [dataManagement]);

  // Aguardar tanto a sessão quanto o usuário estarem definidos
  if (loading || (session && !user)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <div className="text-white text-xl mb-4">Verificando autenticação...</div>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {recoveryMode ? (
        <UpdatePasswordPage />
      ) : !session ? (
        <AuthPage />
      ) : window.location.pathname.startsWith('/admin') ? (
        <AdminLayout />
      ) : (
        <AccessControl>
          {dashboard}
          <NotebookDrawer />
          <TermsAcceptanceDialog
            open={needsTermsAcceptance}
            onAccept={async () => {
              if (!user) return;
              try {
                setAcceptingTerms(true);
                await updateUserMetadata({
                  terms_accepted_at: new Date().toISOString(),
                  terms_version: '1.0',
                });
                toast({
                  title: 'Termos aceitos com sucesso',
                  description: 'Obrigado por confirmar o aceite. Bom uso do sistema!',
                });
              } catch (error) {
                toast({
                  variant: 'destructive',
                  title: 'Erro ao registrar aceite',
                  description: error?.message || 'Não foi possível registrar seu aceite. Tente novamente.',
                });
              } finally {
                setAcceptingTerms(false);
              }
            }}
            onReject={async () => {
              await signOut();
            }}
            isSubmitting={acceptingTerms}
          />
        </AccessControl>
      )}
    </div>
  );
};

function App() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-white text-xl">Carregando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <AppContent />
      <Toaster />
    </div>
  );
}

export default App;

